import { render, staticRenderFns } from "./GlobalSpecsFormTable.vue?vue&type=template&id=7ee847eb&"
import script from "./GlobalSpecsFormTable.vue?vue&type=script&lang=js&"
export * from "./GlobalSpecsFormTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports